export const environment = {
  production: true,
  apiBaseUrl: 'https://apistoryboard.ebu.ch',
  BUGSNAG_API_KEY: 'f9896135ba1c00571f2f22f5c4318a95',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts